<template>
  <v-container>
    <div>
      <v-data-table
        v-if="!showNoUserDepartmentTable && !showEditUserDepartmentTable"
        :loading="loading"
        loading-text="Loading... Please wait"
        :headers="headers"
        :items="processedData"
        :search="search"
        hide-default-footer
        @page-count="pageCount = $event"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="depar-table"
      >
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center" style="margin-top: -4px">
            <v-btn
              color="#4FB14E"
              text
              class="text-capitalize"
              style="font-size: 16px"
              @click="checkDepartmentEdit(item)"
            >
              <v-icon>mdi-square-edit-outline</v-icon>
              {{ $t("edit") }}
            </v-btn>
            <v-btn
              color="error"
              text
              class="text-capitalize"
              style="font-size: 16px"
              @click="checkDepartmentDelete(item)"
            >
              <v-icon>mdi-delete-outline</v-icon>
              {{ $t("delete") }}
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <v-row
        no-gutters
        class="d-flex justify-space-between mt-2"
        v-if="!showNoUserDepartmentTable && !showEditUserDepartmentTable"
      >
        <v-col auto class="d-flex align-center">
          <div class="d-flex text-left">
            <v-pagination
              circle
              class="pagination"
              v-model="page"
              :length="pageCount"
            ></v-pagination>
          </div>
        </v-col>

        <v-col cols="12" lg="2" md="3" sm="4" class="d-flex align-center justify-end">
          <p class="mt-3 pr-4">{{ $t("Show") }}</p>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                width="70"
                v-bind="attrs"
                v-on="on"
                class="text-capitalize mt-1"
                outlined
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in paginationCount"
                :key="index"
                @click="itemsPerPage = item.title"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>

      <MemberList v-if="showNoUserDepartmentTable" />

      <EditMemberList v-if="showEditUserDepartmentTable" />
      <Add
        :show="addNoUserDepartmentDialog"
        @close="$store.commit('closeAddDepartmentDialog')"
        @confirm="addConfirm()"
      />

      <Edit
        :show="editNoUserDepartmentDialog"
        @close="
          $store.commit('closeEditDepartmentDialog'),
            $store.commit('closeStartingDepartmentActive'),
            $store.commit('editNoUserDepartment', false)
        "
        @stopStartingActive="startingActive = false"
        @confirm="editConfirm()"
      />
      <!-- $store.commit('clearSelected'), -->
      <Delete
        :show="deleteDialog"
        :item="deleteData"
        @close="deleteDialog = false"
        @confirm="deleteDepartment(item)"
      />

      <SuccessDialog
        :show="show"
        :text="$t('deletdepartments')"
        :title="$t('success')"
        @close="show = false"
      />
      <SuccessDialog
        :show="addshow"
        :text="$t('adddepartments')"
        :title="$t('success')"
        @close="addshow = false"
      />
      <SuccessDialog
        :show="editshow"
        :text="$t('editdepartmentsuccesss')"
        :title="$t('success')"
        @close="editshow = false"
      />
      <PermissionDialog
        :show="permissionDialog"
        title="Error"
        :text="permissionMessage"
        @close="permissionDialog = false"
      />
    </div>
  </v-container>
</template>

<script>
import Add from "./Add.vue";
import Edit from "./Edit.vue";
import Delete from "./Delete.vue";
import MemberList from "./MemberList.vue";
import EditMemberList from "./MemberListEdit.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Add,
    Edit,
    Delete,
    MemberList,
    EditMemberList,
  },
  props: {
    search: String,
  },
  data: () => ({
    permissionDialog: false,
    permissionMessage: "",
    deleteDialog: false,
    items: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    paginationCount: [
      { title: 5 },
      { title: 10 },
      { title: 20 },
      { title: 30 },
      { title: 40 },
    ],
    loading: true,
    deleteData: {},
    show: false,
    addshow: false,
    editshow: false,
    memberlist: [],
    users: [],
  }),
  computed: {
    ...mapGetters([
      "addNoUserDepartmentDialog",
      "editNoUserDepartmentDialog",
      "showNoUserDepartmentTable",
      "showEditUserDepartmentTable",
      "getUsers",
      "EditselectedUserListdata",
    ]),
    headers() {
      return [
        {
          text: "#",
          value: "no",
          class: "tableColor",
          align: "left",
        },
        {
          text: this.$t("deparmentone"),
          align: "left",
          value: "departmentName",
          class: "tableColor",
        },
        {
          text: this.$t("memberlistsm"),
          align: "center",
          value: "memberList",
          class: "tableColor",
        },
        {
          text: this.$t("Manage"),
          align: "center",
          value: "actions",
          class: "tableColor",
        },
      ];
    },
    processedData() {
      let count = 1;
      return this.items.map((item) => {
        return {
          no: count++,
          departmentId: item.departmentID,
          departmentName: item.departmentName,
          memberList: this.getMemberListCount(item.userLists),
          departmentUsers: item.userLists,
        };
      });
    },
  },
  mounted() {
    this.getDepartment();
  },
  methods: {
    getMemberListCount(userLists) {
      return userLists.length;
    },
    async checkDepartmentDelete(item) {
      this.deleteDialog = true;
      this.deleteData = item;
    },
    async checkDepartmentEdit(item) {
      let checkPermission = this.check_Permissions("usermanagement");
      if (checkPermission) {
        this.$store.commit("openEditNoDepartmentDialog");
        this.$store.commit("saveEditDepartmentData", item);
        this.$store.commit("openStartingDepartmentActive");
        const request = {
          companyId: localStorage.getItem("companyID"),
          departmentId: item.departmentId,
        };
        const res = await this.$axios.post(
          `${this.web_url}Department/GetUserAddDepartment`,
          request
        );
        this.members = res.data.data.users;
        this.$store.commit("EditselectedUserListdata", this.members);
      } else {
        this.permissionDialog = true;
        this.permissionMessage =
          "You don't have permission to edit Department.";
      }
    },
    async checkNoDepartmentAdd() {
      let checkPermission = this.check_Permissions("usermanagement");
      if (checkPermission) {
        const request = {
          companyId: localStorage.getItem("companyID"),
          departmentId: 0,
        };
        const res = await this.$axios.post(
          `${this.web_url}Department/GetUserAddNoDepartment`,
          request
        );
        this.users = res.data.data.users;
        this.$store.commit("NodeptUser", this.users);
        this.$store.commit("openAddNoDepartmentDialog");
      } else {
        this.permissionDialog = true;
        this.permissionMessage = "You don't have permission to add Department.";
      }
    },
    async getDepartment() {
      this.loading = true;
      let checkPermission = true;
      if (checkPermission) {
        const res = await this.$axios.get(
          `${this.web_url}Department/GetAllDepartment?id=` +
            localStorage.getItem("companyID")
        );
        this.items = res.data.data.map((v, i) => ({
          ...v,
          no: i + 1,
        }));
        let itemCount = this.items ? this.items.length : 0;
        this.$emit("itemsCount", itemCount);
      } else {
        this.permissionDialog = true;
        this.permissionMessage =
          "You don't have permission to see Department Data.";
      }
      this.loading = false;
    },

    async deleteDepartment() {
      const userdata = JSON.parse(
        localStorage.getItem("vivek_authenticated_user_data")
      );
      const memberid = userdata.memberId;
      const request = {
        departmentId: this.deleteData.departmentId,
        departmentName: this.deleteData.departmentName,
        companyId: localStorage.getItem("companyID"),
        createOrUpdateBy: memberid,
      };
      const res = await this.$axios.post(
        `${this.web_url}Department/DeleteDepartment`,
        request
      );
      if (res.data.status == 0) {
        this.deleteDialog = false;
        this.show = true;
        this.getDepartment();
      }
    },

    addConfirm() {
      this.$store.commit("closeAddDepartmentDialog");
      this.addshow = true;
      this.getDepartment();
      this.$store.commit("clearSelected");
    },

    editConfirm() {
      this.$store.commit("closeEditDepartmentDialog");
      this.$store.commit("closeStartingDepartmentActive");
      this.editshow = true;
      this.getDepartment();
      this.$store.commit("clearSelected");
      this.$store.commit("clearEditDepartmentData");
    },
  },
};
</script>
<style scoped>
::v-deep .v-label {
  font-size: 20px !important;
}
::v-deep .faq-table tr:nth-child(even) {
  background: #e0e0e0;
}
::v-deep .v-text-field__slot {
  font-size: 16px !important;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 17px !important;
  color: #47484b !important;
  background-color: #dbdbda !important;
  opacity: 1;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 16px !important;
  color: #47484b !important;
  opacity: 1;
  vertical-align: center;
}
::v-deep .v-dialog {
  border-radius: 35px !important;
}
::v-deep .primary {
  color: #000000 !important;
  background-color: #a6cc39 !important;
  opacity: 1;
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
  opacity: 1;
}
</style>

<style>
.depar-table thead th:first-child {
  border-radius: 8px 0 0 8px !important;
}
.depar-table thead th:last-child {
  border-radius: 0 8px 8px 0 !important;
}
</style>
